{"customer":{"userPoolId":"us-east-1_Gakm4C69I","userPoolClientId":"60u4p7kqrr33jrfffbb548jo0i","identityPoolId":null}}